import { useState, useEffect } from 'react';
import LoadingModal from '../components/dumb/LoadingModal';
import MessageTemplateDisplay from "../components/dumb/MessageTemplateDisplay";
import MessageTemplateForm from "../forms/MessageTemplateForm";
import { addMessageTemplate } from '../util/api';

function MessageTemplateAddPage() {
    const [loading, setLoading] = useState(false);
    const [templateName, setTemplateName] = useState('');
    const [templateSubject, setTemplateSubject] = useState('');
    const [templateContent, setTemplateContent] = useState(' ');
    const [params, setParams] = useState('');
    const [paramValues, setParamValues] = useState('');

    useEffect(() => {
      document.title = "Add Message Template"
    }, []);

    return (
        <div>
            <h3 style={{ position: 'relative', left: '45%', marginTop: '20px'}}> Add New Message Template </h3>
            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', marginTop: '50px'  }}>
                <MessageTemplateForm
                    templateName={templateName}
                    setTemplateName={name => setTemplateName(name)}
                    templateSubject={templateSubject}
                    setTemplateSubject={setTemplateSubject}
                    templateContent={templateContent}
                    setTemplateContent={content => setTemplateContent(content)}
                    params={params}
                    setParams={params => setParams(params)}
                    paramValues={paramValues}
                    setParamValues={paramValues => setParamValues(paramValues)}
                    onClick={() => {
                        setLoading(true);
                        addMessageTemplate(templateName, templateSubject, templateContent, params)
                        .then(() => {
                            setLoading(false);
                        })
                        .catch((error) => {
                            console.error(error);
                            setLoading(false);
                        })
                    }}
                />
                <MessageTemplateDisplay
                    templateContent={templateContent}
                    params={params}
                    paramValues={paramValues}
                />
            </div>
            {
                loading && ( <LoadingModal />)
            }
        </div>
    )
}

export default MessageTemplateAddPage;
